export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const RUBRICS = [
  {
    id: "whats-new",
    num: "01",
    title: "What's New",
    en: "NOVITÀ PRODOTTI",
    desc: "L'attrezzatura smontata pezzo per pezzo: canne, segnalatori e pasture analizzate con occhio critico.",
    image: "/photos/mulinelli.jpg",
  },
  {
    id: "inside-the-trade",
    num: "02",
    title: "Inside the Trade",
    en: "DENTRO IL SETTORE",
    desc: "Sales manager, buyer e ufficio marketing: chi lavora nell'industria racconta come nasce un prodotto da carpfishing.",
    image:
      "https://images.unsplash.com/photo-1573330626575-c739d78ceb0a?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "brands",
    num: "03",
    title: "Brands",
    en: "STORIE DI BRAND",
    desc: "I laboratori di famiglia, le ricette che non cambiano e le aziende che hanno fatto la storia della pesca moderna.",
    image: "/photos/boilies-rig.jpg",
  },
  {
    id: "on-the-banks",
    num: "04",
    title: "On the Banks",
    en: "SESSIONI REALI",
    desc: "Grandi catture e cappotti monumentali raccontati senza filtri, con le immagini delle nottate vere.",
    image: "/photos/cattura-carpione.jpg",
  },
  {
    id: "the-hide-side",
    num: "05",
    title: "The Hide Side",
    en: "IL LATO NASCOSTO",
    desc: "Angler senza sponsor, cave senza nome, fiumi che decidono loro: l'anima più recondita della pesca italiana.",
    image: "/photos/brolly-dettaglio.jpg",
  },
];

export const SHORT_LABELS = {
  tutte: "TUTTE",
  "whats-new": "WHAT'S NEW",
  "inside-the-trade": "TRADE",
  brands: "BRANDS",
  "on-the-banks": "BANKS",
  "the-hide-side": "HIDE SIDE",
};

export const FALLBACK_ARTICLES = [
  {
    id: "1",
    rubric: "whats-new",
    episode: "EP.01",
    duration: "14 MIN",
    title: "Cinque oggetti che cambieranno la stagione",
    dek: "Piombo sagomato, boilies a lenta digeribilità e la canna che pesca da sola: l'attrezzatura vista da chi la smonta pezzo per pezzo.",
    location: "LO STUDIO",
    author: "Redazione",
    featured: true,
    image: "/photos/mulinelli.jpg",
  },
  {
    id: "2",
    rubric: "inside-the-trade",
    episode: "EP.02",
    duration: "28 MIN",
    title: "Chi vende la notte",
    dek: "Parliamo con chi lavora nell'industria: sales manager, buyer e ufficio marketing. Come nasce — e come muore — un prodotto da carpfishing.",
    location: "MILANO",
    author: "Redazione",
    featured: true,
    image:
      "https://images.unsplash.com/photo-1573330626575-c739d78ceb0a?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "3",
    rubric: "brands",
    episode: "EP.03",
    duration: "22 MIN",
    title: "Dodici anni, una boilies",
    dek: "I laboratori di famiglia, i fornitori fantasma e le ricette che non cambiano da un decennio. Storie di brand raccontate dal dentro.",
    location: "IL LABORATORIO",
    author: "Redazione",
    image: "/photos/boilies-rig.jpg",
  },
  {
    id: "4",
    rubric: "on-the-banks",
    episode: "EP.04",
    duration: "36 MIN",
    title: "La carpa che non doveva esistere",
    dek: "Settantadue ore in una cava abbandonata con due angler e una macchina da presa. Senza rete, senza sonno, senza certezze.",
    location: "CAVA ABBANDONATA, NORD ITALIA",
    author: "Redazione",
    featured: true,
    image: "/photos/cattura-carpione.jpg",
  },
  {
    id: "5",
    rubric: "the-hide-side",
    episode: "EP.05",
    duration: "19 MIN",
    title: "La cava che nessuno pesca",
    dek: "Luoghi senza nome, angler senza sponsor. La faccia più recondita della pesca italiana, tra sabbia e memoria d'acqua.",
    location: "IN FONDO ALLA DIGA",
    author: "Redazione",
    image: "/photos/brolly-tramonto.jpg",
  },
  {
    id: "6",
    rubric: "on-the-banks",
    episode: "EP.06",
    duration: "24 MIN",
    title: "Notte bianca sul Po grande",
    dek: "Deriva inforcata, piombi pesanti e un fiume che decide lui. Reportage da una sessione da manuale, nebbia compresa.",
    location: "FIUME PO",
    author: "Redazione",
    image: "/photos/carpa-notturna.jpg",
  },
  {
    id: "7",
    rubric: "the-hide-side",
    episode: "EP.07",
    duration: "16 MIN",
    title: "Gli ultimi della diga",
    dek: "In fondo alla diga, dove la rete non arriva, si pesca come trent'anni fa. Abbiamo passato una sera con loro.",
    location: "DIGA, APPENNINO",
    author: "Redazione",
    image: "/photos/bivvy-inverno.jpg",
  },
  {
    id: "8",
    rubric: "brands",
    episode: "EP.08",
    duration: "21 MIN",
    title: "Tre generazioni alla tornitura",
    dek: "Dal tornio alla pompa centrifuga: come nascono i mulinelli che durano vent'anni, e chi li costruisce davvero.",
    location: "L'OFFICINA",
    author: "Redazione",
    image:
      "https://images.unsplash.com/photo-1597957729111-848ad99de4b5?auto=format&fit=crop&w=1600&q=80",
  },
];
